// TODO Remove with https://sdui.atlassian.net/browse/SP-3895
export const categories = {
  MEETING: {
    id: 'MEETING',
    value: 'calendar.event_creation.categories.categories.MEETING',
    icon: 'icon-calendar'
  },
  TRIP: {
    id: 'TRIP',
    value: 'calendar.event_creation.categories.categories.TRIP',
    icon: 'icon-Location'
  },
  EXAM: {
    id: 'EXAM',
    value: 'calendar.event_creation.categories.categories.EXAM',
    icon: 'icon-clock-dots'
  }
}
